import { useSelector, useDispatch } from 'react-redux';
import {toggleUpperModel,  toggleLowerModel, setFrontAngle, toggleMeshed, toggleIpr, toggleAnimation} from '../redux/modelSlice';
import { ReactComponent as IPR } from "../assets/IPR.svg";
import { ReactComponent as IPRActive } from "../assets/IPRActive.svg";
import { ReactComponent as Mesh } from "../assets/Mesh.svg";
import { ReactComponent as MeshActive } from "../assets/MeshActive.svg";
import { ReactComponent as TeethFull } from "../assets/TeethFull.svg";
import { ReactComponent as TeethFullActive } from "../assets/TeethFullActive.svg";
import { ReactComponent as Upper } from "../assets/Upper.svg";
import { ReactComponent as UpperActive } from "../assets/UpperActive.svg";
import { ReactComponent as Lower } from "../assets/Lower.svg";
import { ReactComponent as LowerActive } from "../assets/LowerActive.svg";
import { Tooltip } from "antd"
import * as THREE from "three";
import { headerLogo, primaryColor, secondColor } from 'colors-config';

const Header = ({ setTargetPosition, setReset }) => {

  const dispatch = useDispatch();

  const {
    showUpperModel,
    showLowerModel,
    meshed,
    patientDetails,
    showIpr,
    modelsRemaining
  } = useSelector((state) => state.model);

  const onIPRClick = () => {
    if (showIpr) {
      dispatch(toggleAnimation(true));
      setTimeout(() => dispatch(toggleIpr()), 1000);
    } else {
      dispatch(toggleAnimation(false));
      setTimeout(() => dispatch(toggleIpr()), 500);
    }
  };

  return (
    <div className="header-container">
      <div className="header-col-one">
        <img height={50} src={headerLogo} alt="logo" className="logo-image" />
        {modelsRemaining < 1 && <div className="header-data">
          <div className="header-data-row">
            <p className='caption'>Patient Name:</p>
            <h2 className='value'>{patientDetails?.patient_first_name} {patientDetails?.patient_last_name}</h2>
          </div>
          <div className="header-data-row">
            <p className='caption'>Patient ID:</p>
            <h2 className='value'>{patientDetails?.patient_id}</h2>
          </div>
          {patientDetails?.patient_date_of_birth && <div className="header-data-row">
            <p className='caption'>Date of Birth:</p>
            <h2 className='value'>{patientDetails?.patient_date_of_birth}</h2>
          </div>}
        </div>}
      </div>
      <div className="header-colTwo" style={{ backgroundColor: secondColor}}>
        <div className="icons-one">
          <Tooltip title="IPR(s)/Attachment(s)">
          <div onClick={onIPRClick}  className='icon-div'>
            {" "}
            {showIpr ? <IPRActive /> : <IPR />}
          </div>
          </Tooltip>
          <Tooltip title="Grid view">
          <div onClick={() => dispatch(toggleMeshed())} className='icon-div'>
            {" "}
            {meshed ? <MeshActive /> : <Mesh />}
          </div>
          </Tooltip>
        </div>
        <div className="icons-two">
        <Tooltip title="Upper & Lower Jaw">
          <div
          className='icon-div'
          onClick={() => {
            dispatch(toggleUpperModel(true))
            dispatch(toggleLowerModel(true))
            dispatch(setFrontAngle(true))
            if(showUpperModel && showLowerModel) return setReset(true);
            setTargetPosition(new THREE.Vector3(0, 35, 250));
            
          }}>
            {" "}
            {(showUpperModel && showLowerModel) ? <TeethFullActive /> : <TeethFull />}
          </div>
          </Tooltip>
          <Tooltip title="Upper Jaw">
          <div 
           className='icon-div'
          onClick={() => {
            dispatch(setFrontAngle(true))
            dispatch(toggleUpperModel(true))
            dispatch(toggleLowerModel(false))
            if(showUpperModel) return setReset(true);
            setTargetPosition(new THREE.Vector3(0, 35, 250));
            
          }}>
            {" "}
            {(showUpperModel && !showLowerModel) ? <UpperActive /> : <Upper />}
          </div>
          </Tooltip>
          <Tooltip title="Lower Jaw">
          <div 
           className='icon-div'
          onClick={() => {
            dispatch(setFrontAngle(true))
            dispatch(toggleUpperModel(false))
            dispatch(toggleLowerModel(true))
            if(showLowerModel) return setReset(true);
            setTargetPosition(new THREE.Vector3(0, 35, 250));
            
          }}>
            {" "}
            {(!showUpperModel && showLowerModel) ? <LowerActive /> : <Lower />}
          </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default Header;
